module.exports = __webpack_public_path__ + "img/but2.dfd647a1.png";